import { IncomeBackTo } from "web_myplann/Finances/Types/FinancesNavigationState";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";

export const getIncomeBackRoute = (backTo: IncomeBackTo) => {
	switch (backTo) {
		case IncomeBackTo.Overview:
			return Routing.Finances.Overview.path();
		case IncomeBackTo.Dashboard:
			return Routing.Dashboard.path();
		case IncomeBackTo.Intro:
			return Routing.Finances.Intro.path();
	}
};
